ColorsView = require './change-board-background-colors-component-view'
PhotosView = require './change-board-background-photos-component-view'
React = require 'react'
ReactDOM = require 'react-dom'
View = require 'view'
xtend = require 'xtend'

Component =
  colors: ColorsView
  photos: PhotosView

# Get background prefs
getBackgroundPrefs = (prefs) ->
  out = {}
  for key, value of prefs
    if key.indexOf('background') > -1
      out[key] = value
  out

module.exports = class BoardSettingsView extends View
  viewTitleKey: ->
    if @options.component == 'colors'
      'change background colors'
    else
      'change background photos'

  viewTitleArguments: {
    unsplashUrl: 'https://unsplash.com?utm_source=trello&utm_medium=referral&utm_campaign=api-credit'
  }

  className: 'board-menu-content-frame'

  initialize: ->
    @listenTo @model, 'change:prefs.background change:prefs.backgroundTile change:prefs.backgroundBrightness', @frameDebounce @render
    return

  render: ->
    props =
      boardId: @model.id
      backgroundPrefs: getBackgroundPrefs @model.attributes.prefs

    if @options.component == 'colors'
      props.setBackgroundColor = (name, color) =>
        @model
          .set
            prefs: xtend @model.get('prefs'),
              background: name
              backgroundColor: color
              backgroundImage: null
              backgroundImageScaled: null
          .setPref 'background', name

    Element = React.createElement Component[@options.component], props

    ReactDOM.render Element, @el

    @



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/change-board-background-select-view.coffee